document.addEventListener("DOMContentLoaded", function() {
    const lengthInput = document.getElementById("length");
    const widthInput = document.getElementById("width");
    const calculateButton = document.getElementById("calculate");
    const priceOutput = document.getElementById("calculated-price");
    const areaOutput = document.getElementById("calculated-area");
    const hiddenAreaInput = document.getElementById("hidden-area");
    const hiddenPriceInput = document.getElementById("hidden-price");
    const form = document.querySelector('form[action="/cart/add"]');

    if (!lengthInput || !widthInput || !calculateButton || !priceOutput || !areaOutput || !hiddenAreaInput || !hiddenPriceInput) {
        console.error("Length, width input or other required elements not found.");
        return;
    }

    calculateButton.addEventListener("click", function() {
        const length = parseFloat(lengthInput.value);
        const width = parseFloat(widthInput.value);

        if (isNaN(length) || isNaN(width)) {
            console.error("Invalid input values.");
            return;
        }

        fetch("https://price-calculation-schutznetze-7055b86a2939.herokuapp.com/calculate-price", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ length, width })
        })
        .then(response => response.json())
        .then(data => {
            if (data.calculatedPrice) {
                const area = length * width; // Fläche in Quadratmetern
                const price = parseFloat(data.calculatedPrice);

                areaOutput.textContent = `${area.toFixed(2)} qm`;
                priceOutput.textContent = `€${price.toFixed(2)}`;
                hiddenAreaInput.value = area.toFixed(2);
                hiddenPriceInput.value = price.toFixed(2);
            } else {
                console.error("Invalid response from server:", data);
                priceOutput.textContent = "Error calculating price.";
            }
        })
        .catch(error => {
            console.error("Error fetching price:", error);
            priceOutput.textContent = "Error calculating price.";
        });
    });

    form.addEventListener("submit", function(event) {
        const calculatedPrice = hiddenPriceInput.value;
        if (!calculatedPrice || isNaN(parseFloat(calculatedPrice))) {
            event.preventDefault();
            alert("Bitte berechnen Sie den Preis, bevor Sie das Produkt zum Warenkorb hinzufügen.");
        }
    });
});
